'use client';

import { createContext, useContext } from 'react';

import { FeatureFlag } from '@/server/vendor/launchDarkly';

export type AppContextType = {
  featureFlags: Record<FeatureFlag, boolean>;
};

export const AppContext = createContext<AppContextType>({
  featureFlags: {},
});

export const AppProvider = ({
  children,
  featureFlags,
}: {
  children: React.ReactNode;
  featureFlags: AppContextType['featureFlags'];
}) => {
  return <AppContext.Provider value={{ featureFlags }}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  return useContext(AppContext);
};

export const useFeatureFlag = (flag: FeatureFlag) => {
  const { featureFlags } = useAppContext();
  return featureFlags[flag];
};
